import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const SmallPopup = ({ item, closePopup }) => {
  if (!item) return null;
  const proQty = item.fld_qty - item.fld_balanceqty;

  return (
    <div className="small-popup">
      <div className="popup-content">
        <h4>Processing Details Table</h4>
        <p><strong>Total Qty:</strong> {item.fld_qty}</p>
        <p><strong>Total Processed Qty:</strong> {proQty}</p>           
        <p><strong>Balance Pending Qty:</strong> {item.fld_balanceqty}</p>
        <button className="close-btn" onClick={closePopup}>Close</button>
      </div>
    </div>
  );
};

const PrApprovedListModal = ({ showModal, closeModal, prNo }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (showModal) {
      fetchSuppliers();
    }
  }, [showModal]);

  const fetchSuppliers = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/prApprovalList_data", {
        params: { prNo: prNo },
      });
      setAllSuppliers(response.data);
      setFilteredSuppliers(response.data);
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSuppliers(allSuppliers);
    } else {
      const filtered = allSuppliers.filter(
        (item) =>
          item.supplierMaster_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.supplierMaster_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSuppliers(filtered);
    }
  }, [searchTerm, allSuppliers]);

  const handleSelectItem = (item) => {
    setSelectedItem(item); // Show small popup
  };

  if (!showModal) return null;

  return (
    <>
      
       <div className="modal">
        <div className="modal-content">
          <h3 className="modal-title">Purchase Approved Details</h3>

          <div className="search-results">
            <table>
              <thead>
                <tr>
                  <th>Item Code</th>
                  <th>Description</th>
                  <th>Part Number</th>
                  <th>Price</th>
                  <th>Req Quantity</th>
                  <th>Pending Qty</th>
                  <th>Processing Details</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="8" className="loading-text">Loading...</td>
                  </tr>
                ) : filteredSuppliers.length > 0 ? (
                  filteredSuppliers.map((item) => (
                    <tr key={item.fld_itemcode}>
                      <td>{item.fld_itemcode}</td>
                      <td>{item.fld_desc}</td>
                      <td>{item.fld_drawno}</td>
                      <td>{item.fld_price}</td>
                      <td>{item.fld_qty}</td>
                      <td>{item.fld_balanceqty}</td>
                      <td>
                        <button
                          className="select-btn"
                          onClick={() => handleSelectItem(item)}
                        >
                          Click
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <button className="close-btn" onClick={closeModal}>Close</button>
        </div>
       </div>

      {/* Small Popup for Selected Item (Now Rendered Separately) */}
      {selectedItem && (
        <div className="popup-container">
          <SmallPopup item={selectedItem} closePopup={() => setSelectedItem(null)} />
        </div>
      )}
    </>
  );
};

export default PrApprovedListModal;
